export default function (value) {
	switch (value) {
		case '0':
		case 0:
			return "A/W response";
			break;
		case '1':
		case 1:
			return "To be ordered";
			break;
		case '2':
		case 2:
			return "Ordering";
			break;
		case '3':
		case 3:
			return "In lab";
			break;
		case '4':
		case 4:
			return "Quality control";
			break;
		case '5':
		case 5:
			return "Lenses ready, A/W frame";
			break;
		case '6':
		case 6:
			return "Non tolerance";
			break;
		case '7':
		case 7:
			return "Non tolerance (P)";
			break;
		case '8':
		case 8:
			return "Non tolerance (L)";
			break;
		case '9':
		case 9:
			return "Shipping";
			break;
		default:
			return "UNKNOWN ZONE";
	}
}
